module.exports = __webpack_public_path__ + "img/flexible.17dad23b.png";